import { apiGet } from '../../api'

export const allGroups = () => {
  return apiGet({
    endpoint: 'groups/all_groups'
  })
}
